import React from 'react';
import QRCode from 'react-qr-code';
import QRCodeStyled from './QRCode.styled';

const QRCodeBox = ({
  className,
  path,
}: {
  className?: string;
  path: string;
}) => {
  return (
    <QRCodeStyled className={className}>
      <QRCode size={164} value={path} />
      <span>Scan the QR code</span>
    </QRCodeStyled>
  );
};

export default QRCodeBox;
